const EARLY_ACCESS_SUBDOMAIN = '__next'

export const isEarlyAccess = () =>
  window.location.origin.includes(EARLY_ACCESS_SUBDOMAIN)
